import React from 'react';
import { 
  User, 
  GraduationCap, 
  Briefcase, 
  Award, 
  CheckCircle, 
  Shield, 
  TrendingUp 
} from 'lucide-react';
import marcelino from "../assets/marcelino.png";

const Marcelino = () => {
  const skills = [
    "External/Internal Audits", "Forensic Audit", "Taxation", 
    "Financial Management", "Data Quality Assessments", "Project Management", 
    "Monitoring & Evaluation", "HR Management"
  ];

  return (
    <div className="profile-card">
      <style>{`
        .profile-card {
          font-family: 'Inter', system-ui, sans-serif;
          background: rgba(255, 255, 255, 0.8);
          backdrop-filter: blur(12px);
          border-radius: 24px;
          border: 1px solid rgba(255, 255, 255, 0.3);
          box-shadow: 0 20px 40px rgba(0,0,0,0.05);
          padding: 40px;
          max-width: 900px;
          margin: 20px auto;
          color: #1e293b;
        }
        .hero-section-2 {
          display: flex;
          gap: 32px;
          align-items: center;
          margin-bottom: 40px;
          border-bottom: 1px solid #f1f5f9;
          padding-bottom: 32px;
        }
        .avatar-container {
          position: relative;
          flex-shrink: 0;
        }
        .avatar-img {
          width: 140px;
          height: 140px;
          border-radius: 20px;
          object-fit: cover;
          box-shadow: 0 10px 20px rgba(59, 130, 246, 0.15);
          border: 4px solid white;
        }
        .badge-grid {
          display: flex;
          gap: 8px;
          margin-top: 12px;
        }
        .pill {
          font-size: 12px;
          font-weight: 600;
          padding: 4px 12px;
          background: #eff6ff;
          color: #2563eb;
          border-radius: 100px;
          text-transform: uppercase;
        }
        .grid-layout {
          display: grid;
          grid-template-columns: 1fr 2fr;
          gap: 40px;
        }
        .section-title {
          font-size: 13px;
          font-weight: 700;
          color: #94a3b8;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .skill-tag {
          display: flex;
          align-items: center;
          gap: 10px;
          background: white;
          padding: 12px;
          border-radius: 12px;
          font-size: 14px;
          border: 1px solid #f1f5f9;
          transition: all 0.2s;
        }
        .skill-tag:hover {
          transform: translateY(-2px);
          border-color: #3b82f6;
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
        }
        @media (max-width: 768px) {
          .hero-section-2, .grid-layout { flex-direction: column; grid-template-columns: 1fr; }
          .avatar-img { width: 100px; height: 100px; }
        }
      `}</style>

      <div className="hero-section-2">
        <div className="avatar-container">
          <img src={marcelino} alt="Marcelino Kilyenyi" className="avatar-img" />
        </div>
        <div>
          <h1 style={{ fontSize: '32px', fontWeight: '800', margin: '0 0 4px 0', color: '#0f172a' }}>
            CPA Marcelino Kilyenyi
          </h1>
          <p style={{ fontSize: '18px', color: '#3b82f6', fontWeight: '500', margin: '0' }}>
            CFIP, ACPA-PP, B.Com — Partner
          </p>
          <div className="badge-grid">
            <span className="pill">Auditor</span>
            <span className="pill">Tax Consultant</span>
            <span className="pill">Forensic Specialist</span>
          </div>
        </div>
      </div>

      <div className="grid-layout">
        <aside className="space-y-8">
          <div>
            <h3 className="section-title"><GraduationCap size={16} /> Qualifications</h3>
            <p style={{ fontSize: '15px', lineHeight: '1.6' }}>
              <strong>B.Com in Accounting</strong><br />
              Master’s in M&E (Dissertation Stage)<br />
              <span style={{ color: '#64748b' }}>Member of NBAA & IICFIP (USA)</span>
            </p>
          </div>
          
          <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '16px' }}>
            <h3 className="section-title"><Shield size={16} /> Expertise focus</h3>
            <p style={{ fontSize: '14px', color: '#475569', fontStyle: 'italic' }}>
              "Over a decade of leadership in financial advisory across public, private, and NGO sectors."
            </p>
          </div>
        </aside>

        <main>
          <h3 className="section-title"><Briefcase size={16} /> Career Trajectory</h3>
          <div style={{ color: '#334155', fontSize: '15px', lineHeight: '1.7', marginBottom: '32px' }}>
            Previously <strong>Lead Consultant & Audit Manager</strong> at Kepler Consultants. 
            Transformed organizational controls as <strong>Finance & Admin Manager</strong> at UTSS 
            and mastered project audits at Mekonsult HLB.
          </div>

          <h3 className="section-title"><TrendingUp size={16} /> Core Competencies</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            {skills.map((skill, i) => (
              <div key={i} className="skill-tag">
                <CheckCircle size={14} style={{ color: '#3b82f6' }} />
                {skill}
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Marcelino;